import React, { useState } from 'react';
// @ts-ignore
import styles from './PredefinedPhrasesDiscourseSetup.module.scss';
import AddButton from '../../../../Components/Button/AddButton';
import FlatList from '../../../Base/Components/FlatList';
import ScrollContainer from '../../../Base/Components/ScrollContainer';
import { useLazyDiscoursePhrasesQuery } from '../../../../graphql/graphql';
import useFlatData from '../../../Base/Hooks/useFlatData';
import PredefinedPhrasesDiscourseSetupItem from './PredefinedPhrasesDiscourseSetupItem';
import useDiscoursePredefinedPhrases from '../../Hooks/useDiscoursePredefinedPhrases';
import PredefinedPhrasesDiscoursePhraseFormModal from './PredefinedPhrasesDiscoursePhraseFormModal';
import { SelectValue } from '../../../../Components/Base/Select/Select';

interface Props {
	onEdit?: () => void;
}

export interface PredefineDiscoursePhrase {
	id: string;
	items: {
		type: string;
		extra: { text: string | SelectValue; subType?: string };
	}[];
}

const WRAPPER_ID = 'predefinedPhrasesDiscourseSetup';

const PredefinedPhrasesDiscourseSetup: React.FC<Props> = ({ onEdit }) => {
	const [isNewOpen, setNewOpen] = useState(false);

	const [getMyPhrasesQuery, { data, isLoading }] =
		useLazyDiscoursePhrasesQuery();

	const { getMyPhrases, getNextPage, page, setPage } =
		useDiscoursePredefinedPhrases(getMyPhrasesQuery);

	const { flatData, hasMoreData, loadData } = useFlatData(
		getMyPhrases,
		{
			data: data?.documents?.data,
			totalPages: data?.documents?.meta?.totalPages,
			page: data?.documents?.meta?.page,
		},
		page,
		setPage,
	);

	const handleOnEdit = () => {
		loadData();
		onEdit?.();
	};

	const handleOnCreateNewPhrase = () => {
		setNewOpen(false);
		loadData();
	};

	return (
		<>
			<div className={styles.wrapper}>
				<div className={styles.controls}>
					<AddButton
						onClick={() => setNewOpen(true)}
						title='component.predefinedPhrasesList.addButton'
					/>
				</div>
				<ScrollContainer wrapperId={WRAPPER_ID}>
					<FlatList
						onRefresh={loadData}
						onLoadMore={getNextPage}
						data={flatData}
						isLoading={isLoading}
						hasMoreData={hasMoreData}
						scrollableTargetId={WRAPPER_ID}
						itemKey={'id'}
						className={styles.list}
						renderItem={item => (
							<PredefinedPhrasesDiscourseSetupItem
								item={item}
								key={item.id}
								onEdit={handleOnEdit}
								onDelete={loadData}
							/>
						)}
					/>
				</ScrollContainer>
			</div>
			{isNewOpen && (
				<PredefinedPhrasesDiscoursePhraseFormModal
					isOpen
					onSuccess={handleOnCreateNewPhrase}
					onClose={() => setNewOpen(false)}
				/>
			)}
		</>
	);
};

export default PredefinedPhrasesDiscourseSetup;
